<template lang="pug">
    //- Avoid 'banner' word in class name. AdBlock may remove an element.
    .alert-bnr(ref="container", role="alertdialog", aria-modal="true", aria-labelledby="alert-heading")
        h2#alert-heading.alert-bnr__text
            slot
        .alert-bnr__action
            slot(name="action")
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    name: 'AlertBanner',
    mounted() {
        // TODO: focus on an action
    }
});
</script>

<style lang="scss">
.alert-bnr {
    position: fixed;
    width: #{100% - 8% * 2};
    max-width: 40em;
    left: 50%;
    bottom: 1.43em;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.14em 2em;
    gap: 0.4em 2em;
    background: var(--color-alert-bg, #333333);
    color: var(--color-alert-text, #fff);
    transform: translateX(-50%);
    z-index: 1010;

    @media (--viewport-mobile-m) {
        flex-wrap: wrap;
        padding: 1em 1.4em;
        max-width: 18.6em;

        &__text {
            width: 100%;
        }
    }

    &__text {
        font-size: 1.14em;
        text-wrap: balance;

        @media (--viewport-mobile-m) {
            font-size: 1em;
        }

        a {
            color: var(--color-new-accent-text, #ceff40);
            text-decoration: none;
            font-weight: inherit;
            transition: color 0.2s ease;

            @media (hover: hover) {
                &:hover {
                    color: var(--color-main-hover, #666666);
                }
            }
        }
    }

    @media (--viewport-mobile-m) {
        &__action {
            margin-right: auto;
        }
    }
}
</style>
